module.exports = __webpack_public_path__ + "static/img/most2022.9eeda27.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/most2022.svg
// module id = EiY6
// module chunks = 4